module.exports = __webpack_public_path__ + "img/Iz_liveLoading_Background-min.0ce96812.jpeg";